import useAuth from "hooks/use-auth";
import { Route, Routes, Navigate } from "react-router-dom";

import ResetPassword from "pages/UserPanel/resetPassword";
import UserProfile from "pages/UserPanel/UserInfo";
import Financial from "pages/UserPanel/financial";
import Attendance from "pages/UserPanel/attendance";
import Messages from "pages/UserPanel/messages";
import SingleMessage from "pages/UserPanel/messages/singleMessage";
import UserClasses from "pages/UserPanel/classes";
import ClassFiles from "pages/UserPanel/classes/files";
import UserScores from "pages/UserPanel/score";
import ScoreChart from "pages/UserPanel/score/DisplayChart";
import UserScoresTest from "pages/UserPanel/scoreTest";
import ScoreChartTest from "pages/UserPanel/scoreTest/DisplayChart";
import Conversation from "pages/UserPanel/conversation";
import GetOtpCode from "pages/UserPanel/forgotPassword";
import Login from "pages/login";
import TeacherProfile from "pages/TeacherPanel/TeacherInfo";
import TeacherFinancial from "pages/TeacherPanel/financial";
import TeacherClasses from "pages/TeacherPanel/classes";
import TeacherClassFiles from "pages/TeacherPanel/classes/files";
import EditTeacherClassFiles from "pages/TeacherPanel/classes/files/edit";
import TeacherAttendance from "pages/TeacherPanel/classes/attendance";
import TeacherAddAttendance from "pages/TeacherPanel/classes/attendance/add";
import TeacherEditAttendance from "pages/TeacherPanel/classes/attendance/edit";
import TeacherClassScores from "pages/TeacherPanel/classes/scores";
import AddTeacherClassScore from "pages/TeacherPanel/classes/scores/add";
import EditTeacherClassScore from "pages/TeacherPanel/classes/scores/edit";
import { getUserData } from "store/user-storage";
import { useEffect, useState } from "react";
import TeacherConversation from "pages/TeacherPanel/conversation";
import SendMessage from "pages/TeacherPanel/message";
import GetTeacherOtpCode from "pages/TeacherPanel/forgotPassword";
import ResetTeacherPassword from "pages/TeacherPanel/resetPassword";
import UserDisplayScoresExcellFile from "pages/UserPanel/excell-scores";
import TeacherDisplayScoresExcellFile from "pages/TeacherPanel/excell-scores";
import TeacherAddScoreExcellFile from "pages/TeacherPanel/excell-scores/add";
import TeacherRecievedMessages from "pages/TeacherPanel/message/recievedMessages";
import TeacherDisplaySingleMessage from "pages/TeacherPanel/message/recievedMessages/singleMessage";
import TeacherShowExcellScores from "pages/TeacherPanel/excell-scores/show_scores";
import StudentShowExcellScores from "pages/UserPanel/excell-scores/show_scores";
import DisplayTestScoresList from "pages/TeacherPanel/classes/test_scores";
import ShowTestScores from "pages/TeacherPanel/classes/test_scores/show_scores";

/* جامع */
import ReportCardLevel from "pages/UserPanel/comprehensive/reportCard";
import ReportCardLevelUser from "pages/UserPanel/comprehensive/cExams/userExam";
/* جامع */

import PWAHelper from "components/pwa-helper";

export default function RoutesCM() {
  const AuthCTX = useAuth();
  const [user, setUser] = useState();

  useEffect(() => {
    const userDate = getUserData();
    setUser(userDate);
  }, [AuthCTX.isLoggedIn]);
  if (!AuthCTX.isLoggedIn) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  } else {
    return (
      <>
        <PWAHelper />
        <Routes>
          {user?.type === "student" && !user?.isBlocked && (
            <>
              {/* reset/change/forgot password */}
              <Route path="/get_otp" element={<GetOtpCode />} />
              <Route path="/reset_password" element={<ResetPassword />} />

              {/* user info  */}
              <Route path="/userinfo" element={<UserProfile />} />

              {/* user financial  */}
              <Route path="/financial" element={<Financial />} />

              {/* user attendance  */}
              <Route path="/attendance" element={<Attendance />} />

              {/* messages */}
              <Route path="/messages" element={<Messages />} />
              <Route path="/message/:message_id" element={<SingleMessage />} />

              {/* user classes  */}
              <Route path="/user_classes" element={<UserClasses />} />

              {/* class file  */}
              <Route path="/class/:class_id/files/" element={<ClassFiles />} />

              {/* user scores  */}
              <Route path="/scores" element={<UserScores />} />

              {/* user score chart  */}
              <Route path="/scores/chart" element={<ScoreChart />} />

              {/* user scores test  */}
              <Route path="/scores/exam" element={<UserScoresTest />} />

              {/* user score test chart  */}
              <Route path="/scores/exam/chart" element={<ScoreChartTest />} />

              {/* student conversation  */}
              <Route path="/conversation" element={<Conversation />} />

              {/* student display score excell file */}
              <Route
                path="/user_scores_excell-file"
                element={<UserDisplayScoresExcellFile />}
              />
              <Route
                path="/user_scores_excell-file/:scores_excell_file_id"
                element={<StudentShowExcellScores />}
              />

              {/* جامع */}
              <Route
                path="/comprehensive/user/exams"
                element={<ReportCardLevelUser />}
              />
              <Route
                path="/comprehensive/reportcard/:examId"
                element={<ReportCardLevel />}
              />

              {/* جامع */}

              <Route path="*" element={<Navigate to="/userinfo" />} />
            </>
          )}
          {user?.type === "teacher" && !user?.isBlocked && (
            <>
              <Route path="/techer_info" element={<TeacherProfile />} />

              {/* teacher financial  */}
              <Route path="/teacher_financial" element={<TeacherFinancial />} />

              {/* teacher classes  */}
              <Route path="/teacher_classes" element={<TeacherClasses />} />

              {/* teacher file  */}
              <Route
                path="/teacher_class/:class_id/files"
                element={<TeacherClassFiles />}
              />
              <Route
                path="/teacher_class/file/:file_id"
                element={<EditTeacherClassFiles />}
              />

              {/* teacher attendance  */}
              <Route
                path="/teacher_classes/:class_id/attendance"
                element={<TeacherAttendance />}
              />

              <Route
                path="/teacher_class/:class_id/attendance/add"
                element={<TeacherAddAttendance />}
              />

              <Route
                path="/teacher_class/attendance/:attendance_id/edit"
                element={<TeacherEditAttendance />}
              />

              {/* teacher scores  */}
              <Route
                path="/teacher_class/:class_id/scores"
                element={<TeacherClassScores />}
              />
              <Route
                path="/teacher_class/:class_id/scores/add"
                element={<AddTeacherClassScore />}
              />
              <Route
                path="/teacher_class/:class_id/scores/edit/:score_id"
                element={<EditTeacherClassScore />}
              />
              <Route
                path="/teacher_conversation"
                element={<TeacherConversation />}
              />

              <Route path="/teacher/SendMessage" element={<SendMessage />} />

              <Route path="/teacher/get_otp" element={<GetTeacherOtpCode />} />

              <Route
                path="/teacher/reset_password"
                element={<ResetTeacherPassword />}
              />

              <Route
                path="/teacher_messages"
                element={<TeacherRecievedMessages />}
              />
              <Route
                path="/teacher_messages/:message_id"
                element={<TeacherDisplaySingleMessage />}
              />
              <Route
                path="/teacher_scores_excell-file"
                element={<TeacherDisplayScoresExcellFile />}
              />
              <Route
                path="/teacher_scores_excell-file/:scores_excell_file_id"
                element={<TeacherShowExcellScores />}
              />
              <Route
                path="/teacher_scores_excell-file/add"
                element={<TeacherAddScoreExcellFile />}
              />

              <Route
                path="/teacher_class/:class_id/exam"
                element={<DisplayTestScoresList />}
              />
              <Route
                path="/teacher_class/exam/scores/:scores_excell_file_id"
                element={<ShowTestScores />}
              />

              <Route path="*" element={<Navigate to="/techer_info" />} />
            </>
          )}
          {/* {user.isBlocked && (
            <>
              <Route path="/isBlocked" element={<IsBlockedPage />} />

              <Route path="*" element={<Navigate to="/isBlocked" />} />
            </>
          )} */}
        </Routes>
      </>
    );
  }
}
